import { WHY_CARDS } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const WhyChoose = () => (
  <section id="why" data-testid="why-section" className="bg-beige/40 py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHeading chapter="02" eyebrow="Why Choose Momay" title="The Momay Difference" />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gold/20 border gold-hairline">
        {WHY_CARDS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.06} className="h-full">
            <div
              data-testid={`why-card-${c.n}`}
              className="group relative h-full bg-cream p-8 md:p-10 overflow-hidden hover:bg-espresso transition-colors duration-500"
            >
              <span
                aria-hidden
                className="absolute -top-6 -right-2 font-serif text-[7rem] leading-none text-espresso/5 group-hover:text-gold/10 transition-colors duration-500 select-none"
              >
                {c.n}
              </span>
              <span className="text-gold-dark font-serif text-lg group-hover:text-gold transition-colors duration-500">{c.n}</span>
              <h3 className="mt-4 font-serif text-2xl md:text-3xl text-espresso group-hover:text-cream transition-colors duration-500">
                {c.title}
              </h3>
              <p className="mt-3 text-sm md:text-base font-light text-espresso/60 group-hover:text-cream/60 transition-colors duration-500 leading-relaxed">
                {c.desc}
              </p>
              <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-gold group-hover:w-full transition-all duration-700" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
